export default "__VITE_ASSET__ZjyBn4mO__"